// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1832":"css/admin-app.6959","6410":"css/app.6959"}[chunkId] + ".css";
};